import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'prodNonProductiveWork';

const prodNonProductiveWorkService = {
  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};

export default prodNonProductiveWorkService;
